import { lazy, Suspense, useCallback, useEffect, useState } from 'react';

// A failed optional chunk leaves the static background in place.
const DarkVeil = lazy(() => import('./DarkVeil').catch(() => ({ default: () => null })));

const HeroBackground = () => {
  const [enhanced, setEnhanced] = useState(false);
  const [unavailable, setUnavailable] = useState(false);
  const onUnavailable = useCallback(() => setUnavailable(true), []);

  useEffect(() => {
    const desktop = window.matchMedia('(min-width: 1024px)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    let cancelPending = () => {};
    const update = () => {
      cancelPending();
      if (!desktop.matches || reduced.matches || connection?.saveData) {
        setEnhanced(false);
        return;
      }
      if (window.requestIdleCallback) {
        const id = window.requestIdleCallback(() => setEnhanced(true), { timeout: 1500 });
        cancelPending = () => window.cancelIdleCallback(id);
      } else {
        const id = window.setTimeout(() => setEnhanced(true), 200);
        cancelPending = () => window.clearTimeout(id);
      }
    };
    update();
    desktop.addEventListener('change', update);
    reduced.addEventListener('change', update);
    connection?.addEventListener('change', update);
    return () => {
      cancelPending();
      desktop.removeEventListener('change', update);
      reduced.removeEventListener('change', update);
      connection?.removeEventListener('change', update);
    };
  }, []);

  return (
    <div className="hero-background" aria-hidden="true">
      {enhanced && !unavailable && <Suspense fallback={null}><DarkVeil onUnavailable={onUnavailable} /></Suspense>}
    </div>
  );
};

export default HeroBackground;
